// extracted by mini-css-extract-plugin
export default {"carrousel_wrapper":"Carrousel_carrousel_wrapper__dEfev","carrousel_image":"Carrousel_carrousel_image__Y3Eq4"};